import {
  AlertCircleIcon,
  Loading03Icon
} from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { DateTime } from "luxon";
import { Banner } from "shared/components/Banner";

interface Props {
  initiatedBy?: string | null;
  initiatedAt?: string | null;
  isFinished?: boolean;
}

export const RerunGlobalWarning = ({
  initiatedBy,
  initiatedAt,
  isFinished = false
}: Props) => {
  const formattedDate = initiatedAt
    ? DateTime.fromISO(initiatedAt).toFormat("DDD 'at' h:mm a")
    : "-";
  const initiator = initiatedBy || "-";

  if (isFinished)
    return (
      <div className="mt-4 mb-3">
        <Banner
          variant="base"
          textTheme="base"
          body={`Income re-verification was initiated by ${initiator} on ${formattedDate}`}
          HugeIcon={
            <HugeiconsIcon
              icon={AlertCircleIcon}
              className="shrink-0 text-primary-500"
              size="20"
            />
          }
        />
      </div>
    );

  return (
    <div className="mt-4 mb-3">
      <Banner
        variant="base"
        textTheme="base"
        title="Verification request was sent to the applicant"
        body={`Verification was initiated by ${initiator} on ${formattedDate}`}
        HugeIcon={
          <HugeiconsIcon
            icon={Loading03Icon}
            className="text-warning-600"
            size={20}
          />
        }
      />
    </div>
  );
};
